import axios from './config';

const list = (params, successCb, errorCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/comments`,
    { params },
  ).then(
    res => successCb(res.data),
  ).catch(
    err => errorCb(err),
  );
};

const get = (id, successCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/comment/${id}`,
  ).then(
    res => successCb(res.data),
  ).catch(
    err => console.error('api.comment.get() received error from api request:', err),
  );
};

const countWaiting = (id, successCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/comment/count-waiting`,
  ).then(
    res => successCb(res.data),
  ).catch(
    err => console.error('api.comment.count() received error from api request:', err),
  );
};

const post = (params, successCb, errorCb) => {
  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/comment`,
    params.comment,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const put = (params, successCb, errorCb) => {
  let { comment } = params;

  axios.put(
    `${process.env.REACT_APP_API_BASE_URL}/comment/${params.id}`,
    comment,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const endpoints = {
  list,
  get,
  post,
  put,
  countWaiting,
};

export default endpoints;
